import { render, staticRenderFns } from "./pointsRulesIcon.vue?vue&type=template&id=2ab5c2ab&scoped=true"
import script from "./pointsRulesIcon.vue?vue&type=script&lang=js"
export * from "./pointsRulesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5c2ab",
  null
  
)

export default component.exports